import { render, staticRenderFns } from "./SuitSelect.vue?vue&type=template&id=30733d04&scoped=true&"
import script from "./SuitSelect.vue?vue&type=script&lang=js&"
export * from "./SuitSelect.vue?vue&type=script&lang=js&"
import style0 from "./SuitSelect.vue?vue&type=style&index=0&id=30733d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30733d04",
  null
  
)

export default component.exports